import { FilterState } from './types';
import { EntityMap, Parsed, NetLinkable, RowInvoiceState } from '../types';

function filterInvoiceNumber(i: RowInvoiceState, input: string) {
  return i.number.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) > -1;
}

export function filterRows<F extends Parsed<NetLinkable>>(
  linkable: F[],
  filterState: FilterState,
  entities: EntityMap,
  cond: (i: F) => boolean,
): F[] {
  const { client, payer, type, activity, department, provider, block, invoice } = filterState;

  return linkable.filter((i: F) => {
    if (!cond(i)) {
      return false;
    }

    if (client && client.length > 0 && client.indexOf(i.client_id) === -1) {
      return false;
    }

    if (payer && i.payer_id !== payer) {
      return false;
    }

    if (type && type.length > 0 && type.indexOf(entities.block[i.block_id].type) === -1) {
      return false;
    }

    if (activity && activity.length > 0 && activity.indexOf(i.activity_id) === -1) {
      return false;
    }

    if (department && entities.product[i.product_id].department.id.toString() !== department) {
      return false;
    }

    if (provider && i.provider_id !== provider) {
      return false;
    }

    if (block && block.length > 0 && block.indexOf(i.block_id) === -1) {
      return false;
    }

    if (invoice) {
      return i.state.invoices.some((i) => filterInvoiceNumber(i, invoice));
    }

    return true;
  });
}
